// "Copiar datos del viaje" fuera de la hoja de ruta (PP-65): en el recorrido
// de un viaje ofrecido o aceptado, para cargarlo en el sistema propio de la
// empresa antes de asignar. Mismo texto que en la hoja (`dispatchText`): sin
// pasajeros, porque la API no los manda hasta que el viaje esta asignado.
import { useMemo, useState } from "react";
import { Alert } from "../components/ui/alert.js";
import { Button } from "../components/ui/button.js";
import { dispatchText, type RouteSheet } from "../logic/route-sheet.js";
import { browserRouteSheetActions, type RouteSheetActions } from "./actions.js";

export const DISPATCH_COPIED = "Datos del viaje copiados. Pegalos en el sistema de la empresa y después asigná el móvil por su código.";

type Status = "idle" | "copied" | "failed";

export function DispatchCopy({ sheet, actions }: { sheet: RouteSheet; actions?: RouteSheetActions }): React.JSX.Element {
  const browser = useMemo(() => actions ?? browserRouteSheetActions(), [actions]);
  const [status, setStatus] = useState<Status>("idle");
  return (
    <div className="flex flex-col gap-2">
      <div>
        <Button
          variant="secundario"
          size="sm"
          onClick={() => {
            browser.copy(dispatchText(sheet)).then(
              () => setStatus("copied"),
              () => setStatus("failed"),
            );
          }}
        >
          Copiar datos del viaje
        </Button>
      </div>
      {status === "copied" && <Alert variant="info">{DISPATCH_COPIED}</Alert>}
      {status === "failed" && <Alert variant="error">No se pudo copiar el texto. Copiá los datos a mano desde el recorrido.</Alert>}
    </div>
  );
}
